import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding

const onboardingTechnologySelector = createSelector(
	[getOnboardingData],
	onboarding => {
		const technologyAbbreviations = ['one_to_one', 'byod', 'cart', 'no_devices']
		return {
			technologyIds: technologyAbbreviations[onboarding.technology[0]],
		}
	}
)

export default onboardingTechnologySelector
